export default __webpack_public_path__ + "static/media/desktop-user-details.59dcf157.png";